import React, { useEffect, useState, useRef } from 'react';
import { SuccessModal, Icon, useTheme, Loader, CustomTable, Pagination, Search, Select, ICONS } from '@ohif/ui';
import {
  getALLReports,
} from '../Apis/apis';
import {
  reportColumns
} from './reportTable.helper';
import Modal from './reportModal';
import Header from '../Header/Header';
import { useNavigate } from 'react-router-dom';
import { _routes } from '@custom/Utils/constants/routes';
import { DatePickerWithRange } from '@ohif/ui-next';
import { calculateAge, capitalizeWords, customStyle, formatDate } from '@custom/Utils/utils';
import SendForReviewPopup from './sendtoReviewpopup';
import { RadiologistUser } from './sendtoReviewpopup';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import sendForReview from '@custom/rtk-apis/radiologistuser/sendforReview';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _commonUrls } from '@custom/Utils/constants/apiUrls';
import { Form, Formik } from 'formik';
import { _roleType } from '@custom/Utils/constants/appConstants';
import { Popover } from '@ohif/ui-next';
import { ChevronDown } from 'lucide-react';
import { format, startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfYear, endOfYear } from 'date-fns';

const ReportList = props => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { status, loading, error, msg } = useSelector(
    (state: RootState) => state.sendReviewSliceResponce
  );
  const [isSuccessModalOpen, setIssuccessMopalOpen] = useState(false)
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupdata, setPopupdata] = useState({});
  const [statusvalue, setStatus] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filterData, setFilterData] = useState({
    status: [],
  });
  const [selectedCount, setSelectedCount] = useState(0);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const buttonRef = useRef(null);
  const filterPopupRef = useRef(null);
  const formikRef = useRef(null);
  const role = sessionStorage.getItem("role") || localStorage.getItem("role");
  const { isDarkMode } = useTheme();
  const [diagnosis, setDiagnosis] = useState('');
  const [finalImpression, setFinalImpression] = useState('');

  const resetFilter = () => {
    setStartDate("");
    setEndDate("");
    handleDateChange({ startDate: '', endDate: '' });
    setFilterData({
      status: [],
    });
    setIsFilterOpen(false);
    setStatusFilter({ selectedOptions: '', actions: null });
    setSelectedCount(0);
    setFilterValue({});
    setPgNumber(1);
    setSearchValue(''); // Clear search value
    setDateRange({ startDate: '', endDate: '' }); // Clear date range
    handleFieldChange([]);
    setFinalImpression('');
    setDiagnosis('');
    if (formikRef.current) {
      formikRef.current.resetForm();
      formikRef.current.setFieldValue('status', []);
    }
  };

  const filterFormInitialValue = {
    status: filterData.status || [],
  }

  const handleSaveForm = (values) => {
    setFilterData(values);
    setPgNumber(1);
    setIsFilterOpen(false);
    const selectedOptionsCount = values.status ? values.status.length : 0;
    setSelectedCount(selectedOptionsCount);
    handleFieldChange(values.status);
  }

  const handleResetForm = () => {
    setIsFilterOpen(false);
    setStatusFilter({ selectedOptions: '', actions: null });
    setSelectedCount(0);
    handleFieldChange([]);
    if (formikRef.current) {
      formikRef.current.resetForm();
      formikRef.current.setFieldValue('status', []);
    }
    setFilterData({
      status: [],
    });
  }

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };


  const handleConfirm = (radiologist: RadiologistUser | null) => {
    if (radiologist) {
      const dummyPayload = {
        reportId: popupdata?._id,
        radiologistDetail: {
          userId: radiologist?._id,
          name: radiologist?.name
        }
      };

      dispatch(sendForReview(dummyPayload)).then(() => {
        setIsPopupOpen(false);
        setStatus(true);
        // getReports(pgLimit, pgNumber);
        setIssuccessMopalOpen(true)
        setTimeout(() => {
          getReports(pgLimit, pgNumber);
        }, 2000);

      });
    }
  };

  const handlesuccessCloseModal = () => {
    setTimeout(() => {
      setIssuccessMopalOpen(false)
    }, 1000);
  }

  const [columns, setColumns] = useState([]);
  const [list, setList] = useState([]);
  const [filterValue, setFilterValue] = useState({});
  const [pgNumber, setPgNumber] = useState(1);
  const [pgLimit, setPgLimit] = useState(30);
  const [totalPg, setTotalPg] = useState(1000000);
  const [resetPg, setResetPg] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState({});
  const [reportStatusList, setReportStatusList] = useState([]);
  const [search, setSearch] = useState(false)
  const [statusFilter, setStatusFilter] = useState({
    selectedOptions: '',
    actions: '',
  });

  const [authorize, setAuthorize] = useState(false);
  const [isConfirmingAuthorize, setIsConfirmingAuthorize] = useState(false);
  const [isReportComplete, setReportComplete] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [dateRange, setDateRange] = useState<{ startDate: string; endDate: string }>({
    startDate: null,
    endDate: null
  });

  const presetRanges = [
    {
      label: 'Today',
      getRange: () => {
        const today = new Date();
        return { start: today, end: today };
      }
    },
    {
      label: 'This Week',
      getRange: () => {
        const today = new Date();
        return { start: startOfWeek(today), end: endOfWeek(today) };
      }
    },
    {
      label: 'This Month',
      getRange: () => {
        const today = new Date();
        return { start: startOfMonth(today), end: endOfMonth(today) };
      }
    },
    {
      label: 'This Year',
      getRange: () => {
        const today = new Date();
        return { start: startOfYear(today), end: endOfYear(today) };
      }
    }
  ];

  const handlePresetSelect = (preset) => {
    const { start, end } = preset.getRange();
    const formattedStart = format(start, 'ddMMyyyy');
    const formattedEnd = format(end, 'ddMMyyyy');
    setStartDate(formattedStart);
    setEndDate(formattedEnd);
    setDateRange({ startDate: formattedStart, endDate: formattedEnd });
    handleDateChange({ startDate: formattedStart, endDate: formattedEnd });
  };

  useEffect(() => {
    fetchCommonData()
  }, []);

  const fetchCommonData = async () => {
    try {
      const commonData: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.list, body: {}, headerType: 'json' })
      if (commonData?.status) {
        let data = commonData?.result?.reportListStatus;
        data = data.filter(item => item.value !== "Sent");
        const index = data.findIndex(item => item.value === "Confirmed");
        if (index !== -1) {
          data.splice(index, 1);
        }
        data.push({ value: "Send for Review", label: "Send for Review" });
        setReportStatusList(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const searchClick = searchText => {
    setSearchValue(searchText);
    setFilterValue(prevValues => ({
      ...prevValues,
      name: searchText,
    }))
  }
  const handleDateChange = (dates: { startDate: string, endDate: string }) => {
    const { startDate, endDate } = dates;

    if (startDate && endDate) {
      const formattedStartDate = formatDate(startDate);
      const formattedEndDate = formatDate(endDate);

      setDateRange({ startDate, endDate });
      setStartDate(formattedStartDate);
      setEndDate(formattedEndDate);

      setFilterData(prevValues => ({
        ...prevValues,
        Date: {
          startDate: formattedStartDate,
          endDate: formattedEndDate
        }
      }));

      if (formattedStartDate && formattedEndDate) {
        callReportsAPI(pgLimit, pgNumber, startDate, endDate);
      }
    }
  };

  const handleFieldChange = newValue => {
    setFilterValue(prevValues => ({
      ...prevValues,
      Status: newValue
    }))
  }

  const tableColumn = [
    { key: 'name', title: 'Name', sort: true },
    { key: 'age', title: 'Age' },
    { key: 'gender', title: 'Gender' },
    (role === _roleType.admin || role === _roleType.hospitalSuperadmin) && { key: 'type', title: 'Type' },
    { key: 'modality', title: 'Modality' },
    { key: 'studyRegion', title: 'Study Region' },
    { key: 'priority', title: 'Case Study', sort: true },
    { key: 'date', title: 'Date', sort: true },
    { key: 'patientId', title: 'Patient ID' },
    { key: 'uhid', title: 'UHID' },
    { key: 'reviewedBy', title: "Reviewed By" },
    { key: 'status', title: 'Status' },
    { key: 'actions', title: 'Action' }
  ];

  const actions = [
    {
      label: 'Edit',
      iconName: 'edit',
      onClick: ((item) => {
        setSelectedReport(item);
        setIsModalOpen(true);
        setEditMode(true);
      })
    },
    {
      label: 'Complete',
      iconName: 'confirm',
      onClick: ((item) => {
        handleComplete(item);
        setEditMode(false);
      })
    },
    {
      label: 'Authorize',
      iconName: 'confirm',
      onClick: ((item) => {
        item.status = 'Completed'
        handleAuthorize(item);
        setEditMode(false);
      })
    },
    {
      label: 'Preview',
      iconName: 'preview',
      onClick: ((item) => {
        navigate(_routes.report.previewWithId(item._id), {
          state: {
            fromReportsScreen: true
          }
        })
      })
    },
    {
      label: 'Send for Review',
      iconName: 'review',
      onClick: ((item) => {
        setPopupdata(item)
        setIsPopupOpen(true)
      })
    },
  ];

  const getLatestUsername = (reviewerDetail) => {
    // Check if reviewerDetail is an array
    if (Array.isArray(reviewerDetail) && reviewerDetail.length > 0) {
      // Sort the array by date (assuming date is a string or a Date object)
      reviewerDetail.sort((a, b) => new Date(b.date) - new Date(a.date));

      // Get the latest entry (after sorting by date)
      const latestReviewer = reviewerDetail[0]; // The first element now is the latest by date

      // Return the username if it exists
      return capitalizeWords(latestReviewer.name) || '';
    } else {
      return capitalizeWords(reviewerDetail?.name)
    }
  }

  const getFormatDate = (dateString) => {
    if (dateString?.length !== 8) {
      return '';
    }
    const day = dateString?.slice(0, 2);
    const month = dateString?.slice(2, 4);
    const year = dateString?.slice(4, 8);
    const date = `${year}-${month}-${day}`
    const dateToString = date.toString();
    return dateToString;
  };

  const checkReportStatusBy = (item) => {
    if (item?.status === "Completed") {
      return item?.completedUserName;
    } else if (item?.status === "Authorized") {
      return item?.authorizedUserName;
    } else if (item?.status === "Draft") {
      return item?.draftUserName;
    } else if (item?.status === "Send for Review") {
      return item?.sendForReviewUserName;
    } else {
      return "unknown";
    }
  }
  const checkReportStatusByRole = (item) => {
    if (item?.status === "Completed") {
      return item?.completedUserRole;
    } else if (item?.status === "Authorized") {
      return item?.authorizedUserRole;
    } else if (item?.status === "Draft") {
      return item?.draftUserRole;
    } else {
      return "";
    }
  }

  const callReportsAPI = (pglimit, pgnumber, startDate?, endDate?) => {
    const role = sessionStorage.getItem('role') || localStorage.getItem('role');
    setIsLoading(true);
    const updatedStartDate = getFormatDate(startDate || dateRange.startDate)
    const updatedEndDate = getFormatDate(endDate || dateRange.endDate);
    // Set modality to 'SM' for technician and Pathology role
    let updatedFilter = { ...filterValue };
    if (role == _roleType.technician || role == _roleType.pathologist) {
      updatedFilter.modality = 'SM';
    }
    else if (role == _roleType.pathologistAdmin) {
      updatedFilter.modality = 'SM';
    }

    if(finalImpression) {
      updatedFilter.finalImpression = finalImpression
    }

    if(diagnosis){
      updatedFilter.diagnosis = diagnosis
    }

    getALLReports(updatedFilter, pglimit, pgnumber, updatedStartDate.toString(), updatedEndDate.toString())
      .then(items => {
        setColumns(reportColumns);
        setTotalPg(items?.totalContent);

        let tempArray = [];

        items?.reportList?.map((item) => {
          // For radiologistAdmin, skip items with modality 'SM'
          if (role === _roleType.radiologistAdmin && item.modality === 'SM') {
            return;
          }
          tempArray.push({
            ...item,
            date: formatDate(item?.date) || "--",
            age: calculateAge(item.age || 0),
            reviewedBy: item.reviewerDetail ? getLatestUsername(item.reviewerDetail) : "--",
            studyRegion: item?.studyRegion ? item?.studyRegion : "--",
            patientId: item?.patientId ? item?.patientId : "--",
            name: item?.name
              ? item.name
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')
              : '--',
            gender: item?.gender ? item?.gender : "--",
            modality: item?.modality ? item?.modality : "--",
            priority: item?.priority ? item?.priority : "--",
            status: item?.status ? item?.status : "--",
            reportMadeBy: checkReportStatusBy(item),
            reportMadeByRole: checkReportStatusByRole(item),
            uhid: item?.uhid ? item?.uhid : "--",
            type: item?.hospitalIds.length === 2 ? 'Teleradiologist' : '--',
            rollbackStatus: item?.rollbackStatus,
          });
        });

        // Sort reports by the 'time' or 'date' key
        tempArray.sort((a, b) => {
          const timeA = new Date(a.time || a.date).getTime(); // If 'time' doesn't exist, fallback to 'date'
          const timeB = new Date(b.time || b.date).getTime();

          return timeB - timeA; // Sort descending, latest first
        });

        setList(tempArray);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getActionAccordingToRole = (actions) => {
    if (role === 'Front Desk' || role === 'Nurse' || role === 'Government') {
      const action = actions.filter(action => action.label === 'Preview');
      return action
    }
    else if (role === 'Resident') {
      return actions.filter(action => action.label !== 'Authorize');
    }
    else {
      return actions
    }
  }

  const getReports = (pglimit, pgnumber) => {
    if (
      !filterValue.name &&
      !filterValue.modality &&
      !filterValue.age &&
      !filterValue.gender &&
      !filterValue.startDate &&
      !filterValue.endDate &&
      !filterValue.time &&
      !filterValue.patientId &&
      !filterValue.uhid &&
      !filterValue.status
    ) {
      //Search is cleared
      setResetPg(!resetPg);
      callReportsAPI(pglimit, pgnumber);
    } else {
      //Search is not clear
      setResetPg(!resetPg);
      callReportsAPI(pglimit, pgnumber);
    }
  };

  const handlePageSizeChange = e => {
    callReportsAPI(e, pgNumber);
    setPgLimit(e);
  };

  const onPageChangeHandler = pg => {
    callReportsAPI(pgLimit, pg);
    setPgNumber(pg);
  };

  const searchHandler = () => {
    getReports(pgLimit, pgNumber)
  }

  const handleAuthorize = (report) => {
    setSelectedReport(report);
    setIsModalOpen(true);
    setAuthorize(true);
  }

  const handleComplete = (report) => {
    setAuthorize(false);
    setSelectedReport(report);
    setIsModalOpen(true);
  }

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setAuthorize(false);
    setIsAuthorized(false);
    setSelectedReport(null);
  };

  useEffect(() => {
    searchHandler();
  }, [filterValue]);

useEffect(() => {
  const debounceTimer = setTimeout(() => {
    callReportsAPI(pgLimit, pgNumber);
  }, 500);

  return () => clearTimeout(debounceTimer);
}, [finalImpression, diagnosis]);

// Handle click outside filter popup
useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      isFilterOpen &&
      filterPopupRef.current &&
      !filterPopupRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setIsFilterOpen(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [isFilterOpen]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedReport(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    setAuthorize(false);
  }, [isAuthorized]);

  useEffect(() => {
    setAuthorize(false);
    setIsAuthorized(false);
  }, [isConfirmingAuthorize]);

  const handleSave = () => {
    const updatedReport = {
      ...selectedReport,
      status: "Completed",
    };
  };

  const handleAuthorizeComplete = () => {
    const updatedReport = {
      ...selectedReport,
      status: "Authorized",
    };
  };

  const handleCancel = () => {
    handleCloseModal();
  };

  const setSearchClear = () => {
    setSearch(false);
  }

  return (
    <>
      <div className='page page__fullBody' style={
        isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
      }>
        <Header isBack={false} title='Reports'></Header>
        <div className='page__body'>
          <div className='tableWrap'>
            <div className='tableWrap__head' style={{ justifyContent: "normal" }}>
              <div className="formRow formRow__3 m_0 w_100 formRow--flexEnd">
                <div className='formCol'>
                  <Search text="Name" onSearchClick={searchClick} value={searchValue} setValue={setSearchValue}></Search>
                </div>
                <div className='formCol'>
                  <div className='form-groupfield'>
                    <input
                      id='finalImpression'
                      placeholder='Final impression'
                      className='custom-bg-white'
                      value={finalImpression}
                      type='text'
                      onChange={(e) =>
                       setFinalImpression(e.target.value)
                     }
                     />
                  </div>
                  <div className='form-groupfield'>
                     <input
                       id='diagnosis'
                       placeholder='Diagnosis'
                       className='custom-bg-white'
                       type='text'
                       value={diagnosis}
                       onChange={(e) => {
                         setDiagnosis(e.target.value)
                        }}
                        />
                  </div>
                </div>
                <div className='formCol z-50' style={{ overflow: 'visible', minWidth: '100%' }}>
                  <Popover.Popover>
                    <Popover.PopoverTrigger asChild>
                      <button
                        className={
                          'flex h-[32px] mt-2 min-w-[200px] items-center justify-between rounded border px-3 text-sm z-50 ' +
                          (!isDarkMode ? 'bg-transparent text-black' : 'bg-white text-black')
                        }
                        style={{ color: isDarkMode ? 'white' : 'black', opacity: 1, position: 'relative' }}
                      >
                        <span style={{ color: isDarkMode ? 'white' : 'black',  opacity: 1, display: 'inline-block' }}>Quick Select</span>
                        <ChevronDown className="ml-2 h-4 w-4" />
                      </button>
                    </Popover.PopoverTrigger>
                    <Popover.PopoverContent className="w-auto p-0" align="start">
                      <div className="flex flex-col">
                        {presetRanges.map((preset) => (
                          <button
                            key={preset.label}
                            className="px-4 py-2 text-left text-sm hover:bg-gray-100"
                            onClick={() => handlePresetSelect(preset)}
                          >
                            {preset.label}
                          </button>
                        ))}
                      </div>
                    </Popover.PopoverContent>
                  </Popover.Popover>
                  <DatePickerWithRange
                    className="px-4 py-1 rounded h-10"
                    onChange={handleDateChange}
                    startPlaceholder="From"
                    endPlaceholder="To"
                    startDate={dateRange.startDate}
                    endDate={dateRange.endDate}
                    style={{ width: '200px' }}
                  />
                </div>
                <div className="formCol" style={{ position: 'relative' }}>
                  {selectedCount > 0 && (
                    <span className="badge absolute top-0 left-0 translate-x-1/2 translate-y-1/2">
                      {selectedCount}
                    </span>
                  )}
                  <div className='btn__group'>
                    <button
                      ref={buttonRef}
                      onClick={() => setIsFilterOpen(!isFilterOpen)}
                      className="filter-button relative"
                    >
                      <img src={ICONS.filterIcon} alt="down arrow" /> Filter
                    </button>
                    <button onClick={resetFilter} className="filter-button" style={{ marginLeft: '5px' }}>
                      <Icon name="ClearFilters" className="text-black cursor-pointer" width="16" height="16"></Icon>
                      Clear
                    </button>
                  </div>
                  {isFilterOpen && (
                    <div
                      ref={filterPopupRef}
                      className="filter-popup"
                      style={{
                        position: 'absolute',
                        top: buttonRef.current.offsetHeight + 10,
                        left: 0,
                        zIndex: 100,
                        backgroundColor: "#ffffff",
                        border: '1px solid #ccc',
                        padding: '10px',
                        width: "500px",
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                      }}
                    >
                      <Formik
                        key={JSON.stringify(filterData)}
                        initialValues={filterFormInitialValue}
                        onSubmit={(values, { setSubmitting }) => {
                          handleSaveForm(values);
                          setSubmitting(false);
                          setIsFilterOpen(false);
                          const selectedOptionsCount = values.status ? values.status.length : 0;
                          setSelectedCount(selectedOptionsCount);
                          handleFieldChange(values.status);
                        }}
                      >
                        {({ values, setFieldValue, handleSubmit }) => (
                          <Form onSubmit={handleSubmit}>
                            <div className='formRow' style={{ height: "85px" }}>
                              <div className='formCol' style={{ width: "100%" }}>
                                <label htmlFor='status' className="filterPopupLabel">Status</label>
                                <Select
                                  id='status'
                                  placeholder='Select'
                                  className='custom-bg-white'
                                  isMulti={true}
                                  isClearable={false}
                                  isSearchable={true}
                                  closeMenuOnSelect={false}
                                  hideSelectedOptions={false}
                                  options={reportStatusList}
                                  value={values.status}
                                  onChange={(selectedOptions, action) => {
                                    setFieldValue('status', selectedOptions);
                                    setStatusFilter({ selectedOptions, actions: action });
                                  }}
                                />
                              </div>
                            </div>

                            <div className='filter-bottom'>
                              <button type="button" className='mr-2 custom-button' onClick={handleResetForm}>Clear</button>
                              <button
                                type="submit"
                                className='custom-button main-theme'
                              >
                                Apply
                              </button>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='tableContainer'>
              {isLoading ? <Loader isLoaderOpen={isLoading} /> : <CustomTable columns={tableColumn} data={list} actions={getActionAccordingToRole(actions)} searchQuery={""} from="report" userDetails={''} setClickedItem={''} clickedItem={''} />}
            </div>
          </div>
        </div>
        {list.length > 0 && <Pagination
          onChangePage={onPageChangeHandler}
          onChangePerPage={handlePageSizeChange}
          totalPage={totalPg}
          currentPage={pgNumber}
          perPage={pgLimit}
        />}
        {isModalOpen && (
          <Modal
            isOpen={isModalOpen}
            editMode={editMode}
            title={
              editMode
                ? "Edit Report"
                : (isConfirmingAuthorize
                  ? ""
                  : (authorize)
                    ? "Authorize Report"
                    : isAuthorized
                      ? "Authorize Report!"
                      : "Complete Report")
            }
            onClose={handleCloseModal}
            closeButton={true}
            containerDimensions="80vw, 80vh, 80vh,80vh"
            onSave={handleSave}
            onAuthorize={handleAuthorizeComplete}
            onCancel={handleCancel}
            setIsConfirmingAuthorize={setIsConfirmingAuthorize}
            setReportComplete={setReportComplete}
            setIsAuthorized={setIsAuthorized}
            setSelectedReport={setSelectedReport}
            handleInputChange={handleInputChange}
            selectedReport={selectedReport}
            isAuthorized={isAuthorized}
            isConfirmingAuthorize={isConfirmingAuthorize}
            getReports={getReports}
            setIsModalOpen={setIsModalOpen}
            updateReportInformation={''}
          >
            {isConfirmingAuthorize ? (
              <SuccessConfirmationModal
                handleCloseModal={handleCloseModal}
                setIsConfirmingAuthorize={setIsConfirmingAuthorize}
                title="Report Authorized Successfully!"
              />
            ) : isAuthorized && (
              <p style={{
                fontWeight: 400,
                lineHeight: '20px',
                textAlign: 'left',
                color: 'black',
                padding: '20px',
                paddingLeft: '10px',
                borderRadius: '8px',
              }}>
                Are you sure you want Authorize this report?
              </p>
            )}
          </Modal>
        )}
      </div>
      <SendForReviewPopup
        isOpen={isPopupOpen}
        onConfirm={handleConfirm}
        onCancel={handleClosePopup}
        patientName={popupdata?.name || ""}
        reportTitle={popupdata?.reportName || ""}
        age={popupdata?.age || ""}
        gender={popupdata?.gender || ""}
        patientid={popupdata?.patientId || ""}
        modality={popupdata?.modality || ""}
      />
      <SuccessModal isSuccessModalOpen={isSuccessModalOpen}
        handleCloseModal={handlesuccessCloseModal}
        title={`${msg}.`} >
      </SuccessModal>
    </>
  );
};

export const SuccessConfirmationModal = ({ handleCloseModal, setIsConfirmingAuthorize, title }) => {
  setTimeout(() => {
    handleCloseModal(); // Call your function to close the modal
    setIsConfirmingAuthorize(false);
  }, 800)
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '200px',
          height: '100%',
          textAlign: 'center',
          borderRadius: '32px',
          padding: '10px 10px 0px 10px',
        }}>
        <Icon
          name="SuccessCircle"
          className="text-black cursor-pointer"
        />
      </div>
      <p style={{
        fontFamily: 'Poppins, sans-serif',
        fontSize: '23.14px',
        fontWeight: 600,
        lineHeight: '34.71px',
        textAlign: 'center',
        color: 'black',
        padding: '0px 20px 60px 20px',
        borderRadius: '8px',
        marginTop: '0px',
      }}>
        {title}
      </p>
    </>
  )
}

export default ReportList;
